import React, { useEffect } from "react";
import Button from "react-bootstrap/Button";
import { useDispatch } from "react-redux";
import { setFormAnswer } from "../../ducks/checkoutSlice";
import QRCodeScanner from "../../components/QRCodeScanner";

const STEP_Comanda = "STEP_Comanda";

function ComandaScanJava({ moveStep }) {
  const dispatch = useDispatch();

  useEffect(() => {
    window.posNativeInterface.startScanComanda();
  }, []);

  const onScanComanda = (qrData) => {
    dispatch(
      setFormAnswer({
        name: "comandaId",
        value: qrData,
      })
    );
    moveStep(1);
  };

  window.javaNative_onScanComanda = onScanComanda;
  window.javaNative_moveStep = moveStep;

  return <div></div>;
}

function ComandaScanJS({ moveStep }) {
  const dispatch = useDispatch();

  const onScanComanda = (qrData) => {
    dispatch(
      setFormAnswer({
        name: "comandaId",
        value: qrData,
      })
    );
    moveStep(1);
  };

  return (
    <div>
      <p className="py-5 totem-header">Aponte sua comanda para a camera</p>
      <QRCodeScanner onScanComanda={onScanComanda} />
      <Button
        className="totem-checkout-back-button mt-5"
        variant="outline-dark"
        onClick={() => moveStep(false)}
      >
        Voltar
      </Button>
    </div>
  );
}

export default function ComandaScan({ step, moveStep }) {
  if (step !== STEP_Comanda) return null;

  return window.posNativeInterface ? (
    <ComandaScanJava moveStep={moveStep} />
  ) : (
    <ComandaScanJS moveStep={moveStep} />
  );
}
